import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isCocaAnnual: true
}

const cocaAnnualCommonSlice = createSlice({
    name: 'cocaAnnualCommon',
    initialState,
    reducers: {
        isCocaAnnual: (state, action) => {
            state.isCocaAnnual = action.payload;
        }
    }
})

export const { isCocaAnnual } = cocaAnnualCommonSlice.actions;
export default cocaAnnualCommonSlice.reducer